import ContextualMenuItemList, { ContextualMenuItemListProps } from './ContextualMenuItemList';

export type { ContextualMenuItemListProps };
export default ContextualMenuItemList;
